import ImageWithSkeleton from "@/components/ui/ImageWithSkeleton";
import { useSignedUrl } from "@/hooks/useSignedUrl";
import { IProject } from "@/types";
import { motion } from "framer-motion";

const fadeUpVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
};

const ProjectCard = ({ project }: { project: IProject }) => {
    const { signedUrl, isLoading } = useSignedUrl(project.image?._id);
    return (
        <motion.div
            variants={fadeUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="flex h-full flex-col rounded-2xl border border-border-color p-4"
        >
            <ImageWithSkeleton
                src={signedUrl}
                alt={project.name}
                isLoadingUrl={isLoading}
                width={0}
                height={0}
                sizes="100vw"
                containerClassName="mb-2 aspect-[16/10] w-full rounded-xl"
                className="h-full w-full rounded-xl object-contain"
            />
            <h3 className="truncate py-2 text-xl font-bold md:text-lg">
                {project.name}
            </h3>
            <div className="mb-2 flex flex-wrap gap-2">
                {project.skills.map((skill, index) => (
                    <span
                        key={index}
                        className="rounded-full bg-card-bg-hover px-2.5 py-0.5 text-xs text-text-color"
                    >
                        {skill}
                    </span>
                ))}
            </div>
            <div className="mt-auto flex flex-1 items-end justify-between gap-4 pt-4">
                {project.links.code && (
                    <a
                        href={project.links.code}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-pill-primary-outline flex-1"
                    >
                        GitHub
                    </a>
                )}
                {project.links.live && (
                    <a
                        href={project.links.live}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-pill-primary-outline flex-1"
                    >
                        Live
                    </a>
                )}
            </div>
        </motion.div>
    );
};

export default ProjectCard;
